import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  SimpleChange,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
import { DialogService } from "ng2-bootstrap-modal";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { UtilityServiceService } from "app/services/utility-service.service";
import { AlertComponent } from "app/popup/alert.component";
import { ErrorComponent } from "app/popup/error.component";
import { DocumentsServiceService } from "../services/documents-service.service";
import { DocumenttypeService } from "../services/documenttype.service";
import { LinkedUploadedDocument } from "app/interfaces/documents.interface";
import { CarrierService } from "app/services/carrier.service";
import { AuthWebService } from "app/services/authweb.service";
import { Account } from "app/constants/account.enum";
import { environment } from "environments/environment";
import { ToastrService } from "ngx-toastr";
import { PopupService } from "app/services/shared/popup.service";
import { DomSanitizer } from "@angular/platform-browser";
import { catchError } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { DatePipe } from "@angular/common";
import { ScannerService } from "app/services/scanner.service";
import { Alert } from "selenium-webdriver";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

@Component({
  selector: "uploaddocument",
  templateUrl: "./uploaddocument.component.html",
  styleUrls: ["./uploaddocument.component.scss"],
})
export class UploaddocumentComponent implements OnInit {
  @ViewChild("fileupload") uploader: ElementRef;
  @Input() dataCntrl: any;
  @Input("ctrlPages") ctrlPages: any;
  acc = Account;
  CarrierId: any;
  carrier_type_id: any;
  name: any;
  cresult: any;
  UserDocuments: any = [];
  DocTypesList: any = [];
  hasDocuments: boolean = false;
  fileToUpload: File = null;
  fileName = "";
  isRemove = false;
  removeRef: any;
  img: any;
  page = 1;
  lblHeading = "";
  isEmpty: boolean = false;
  isViewMode: boolean = false;
  sub: any;
  user = { LastName: "" };
  isProcess: boolean = true;
  pdfSrc: any;
  //Uploaded file data
  filebytes: string;
  filename: string;
  filetype: string;
  filesize: string;
  filedescription: string;
  isPromptUserToScan = false;
  scannerMessage =
    "Please go and insert your paper to the scanner and click the scan button";
  selectedScanner: any;
  scannedDocument: any;

  //Checking if it is kiosk mode
  isKiosk: boolean = false;

  @Input("isAnnualCompliance") isAnnualCompliance: boolean = false;
  scanDocumentId: any;

  isView: boolean; //Check if the component is needed for viewing or uploading
  isLinkedDocument: boolean;
  showOtherUploadsOption = false;
  hasCategorySelected = false;
  validParent = true;
  isEdit = true;
  isLoadingImg = false;
  //Object for document to be preview or downloaded
  previewDocument: any = [];
  otherdoctype: any = [];

  documenttypeid: number;
  file: File;
  spinner: boolean;

  catDocuments: any = [];
  uploadedDocuments: any = [];

  LinkedUploadedDocuments: any = [];
  AllDocuments: any = [];

  popoverTitle = "Delete Document";
  popoverMessage = "Are you sure you want to delete a document?";
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = "";
  message = "Loading Documents...";
  public isLoading = false;
  isPDF: number = 0;
  doc: any;
  maxMB: any;
  isDocUnavail = false;
  // list documents that the carrier has
  // list documents for its carrier type must upload
  // so its linked - the existing documents
  // interface required documents not uploaded yet

  /*Bongani*/
  carrier_id: number;
  dtype;
  public isExternalRole: boolean = true;
  constructor(
    private documentService: DocumentsServiceService,
    private documenttypeService: DocumenttypeService,
    private router: Router,
    private route: ActivatedRoute,
    private carrierService: CarrierService,
    private authWebService: AuthWebService,
    private sanitizer: DomSanitizer,
    private confirm: PopupService,
    private toastService: ToastNotificationService,
    private utility: UtilityServiceService,
    private ref: ChangeDetectorRef,
    private toastr: ToastrService,
    private confirmDialogService: ConfirmDialogService,
    public datepipe: DatePipe,
    private scanner: ScannerService
  ) {}

  ngOnInit() {
    this.maxMB = environment.authWebApi.systemData.Configurations.find(
      (p) => p.Code == "MaxUploadMB1"
    ).Value;
    this.dtype = environment.authWebApi.systemData.Configurations.find(
      (p) => p.Code == "UploadDocTypes1"
    ).Value;

    //this.lblHeading = 'Document Uploads';
    this.user.LastName = this.authWebService.userData
      ? this.authWebService.userData.User.LastName
      : "";

    this.carrier_id = this.utility.ctrlPages[Account.First].carrierId;
    ////console.log(this.carrier_id)
    this.getCarrierData();
    this.isProcess = false;

    if (!this.authWebService.userData.Roles[0].IsExternalRole) {
      this.isExternalRole = false;
    }
  }

  getCarrierData() {
    this.isLoading = true;
    this.carrierService.getById(this.carrier_id).subscribe(
      (result: any) => {
        this.carrier_type_id = result.carrier_type_id;
        this.name = result.name;
        //Only call these guys once you have the type id you are looking for.
        this.isLoading = false;
        if (this.carrier_type_id > 0) {
          this.populateDocTypeList();
        }
      },
      (error) => {
        this.isLoading = false;
        // this.dialogService.addDialog(ErrorComponent, { title: 'Document Uploads', message: `Unable to retrieve carrier details.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
        this.toastService.error(
          `A problem occured while retrieving carrier type's documents.`,
          "Document Uploads"
        );
      }
    );
  }
  populateDocTypeList() {
    // for this carrier get the related doc types
    this.isLoading = true;
    this.documenttypeService
      .getDocTypeLinkByCarrierTypeId(this.carrier_type_id)
      .pipe(
        catchError((err) => {
          this.isLoading = false;
          if (err.status == 404) {
            this.isDocUnavail = true;
            this.toastService.error(
              `There are no documents linked to this carrier type.`,
              "Document Uploads"
            );
          } else {
            this.toastService.error(
              `Unable to retrieve linked document types to given carrier type.`,
              "Document Uploads"
            );
          }
          return of([]);
        })
      )
      .subscribe(
        (result: any) => {
          this.DocTypesList = result.linked;
          //console.log('DocTypesList : ', this.DocTypesList);
          if (this.DocTypesList != null) {
            this.getCarrierExistingDocuments();
          }
          this.checkIfKiosk();
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  getCarrierExistingDocuments() {
    this.isLoading = true;
    this.documentService.getByCarrierId(this.carrier_id).subscribe(
      (result:any) => {
        this.UserDocuments = result.filter(x => x.docType !== "Supporting documents for motivation of service" && x.group_code !== "OCASDRIVER" && x.group_code !== "OCASRCP");
        console.log(result);
        if (this.UserDocuments.length > 0) {
          this.isEmpty = false;
          // this.removeUploadedDocTypes();
        }
      },
      (error) => {
        this.isEmpty = true;
        this.UserDocuments = [];

        this.isLoading = false;
        // this.dialogService.addDialog(ErrorComponent, { title: 'Document Uploads', message: `Unable to retrieve carrier documents.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      }
    );
  }
  removeUploadedDocTypes() {
    this.isLoading = true;

    if (this.UserDocuments.length > 0) {
      let count = this.UserDocuments.length;

      for (let knt = 0; knt < count; knt++) {
        let index = this.isDocTypeInList(
          this.UserDocuments[knt].document_type_id
        );
        if (index != -1) {
          this.DocTypesList.splice(index, 1);
        }
      }
    }
    this.isLoading = false;
  }
  isDocTypeInList(id: number) {
    let count = this.DocTypesList.length;
    for (let iter = 0; iter < count; iter++) {
      if (this.DocTypesList[iter].document_type_id == id) return iter;
    }
    return -1;
  }
  reload() {
    this.getCarrierData();
  }
  onChangeHeading(change: boolean = true) {
    this.lblHeading = change ? "Documents" : "Delete Document";
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeading();
  }

  onDelete(doc: any) {
    this.isLoading = true;
    this.message = "Deleting selected document. Please wait...";
    this.documentService.delete(doc.id).subscribe(
      (result) => {
        // this.dialogService.addDialog(AlertComponent, { title: 'Delete Document', message: `Document ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
        this.toastService.success(
          `Document ${doc.code} deleted.`,
          "Delete Document"
        );

        //if (result != null) {
        // this.onNo();
        this.isLoading = false;
        this.reload();
        //}
        //this.onChangeHeading();
      },
      (error) => {
        error = error.json();
        this.isLoading = false;
        // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Document', message: `Document ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
        this.toastService.error(
          `Document ${this.removeRef.code} was not deleted.`,
          "Delete Document"
        );
      }
    );
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.fileName = files.item(0).name;
  }
  onFileSelected(event: any, documenttypeid: any) {
    this.setFileData(event, "upload", documenttypeid);
  }

  setFileData(event: any, description: any, documenttypeid: any) {
    if (documenttypeid != null) {
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
        let file: any = null;
        const count = event.target.files.length;

        file = event.target.files[count - 1];
        let result = this.checkFileType(file.name);
        let fileFound = false;

        console.log("FileName", file.name);
        console.log("Docs", this.UserDocuments);

        this.UserDocuments.forEach(
          function (value) {
            if (file.name == value.file_name) {
              fileFound = true;
              this.toastService.error(
                `You already uploaded this file`,
                "File upload failed"
              );
              return false;
            }
          }.bind(this)
        );

        if (fileFound) {
          return;
        }

        //if File type is in not found
        if (result != -1) {
          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

            reader.removeEventListener;
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.filebytes = reader.result.toString().split(",")[1];
              (this.filename = file.name), (this.filetype = file.type);
              this.filedescription = description;
              this.filesize = file.size;
              this.validateData(documenttypeid);
            };
          } else {
            this.uploader.nativeElement.value = "";
            let allowedFileSize =
              environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == "MaxUploadMB1"
              );
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(
              `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
              "File Upload Failed, Please try again."
            );
          }
        } else {
          //send message allowed types
          this.uploader.nativeElement.value = "";
          let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
              (p) => p.Code == "UploadDocTypes1"
            );

          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed: PDF  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastService.error(
            `Only these file types are allowed: PDF`,
            "File Upload Failed, Please try again."
          );
        }
      }

      this.uploader.nativeElement.value = "";
      // this.showOtherUploadsOption = false;
    }
  }

  checkFileType(fileName: string) {
    // from the file name derive the extension
    let allowedFileTypes =
      environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == "UploadDocTypes1"
      );
    let fileTypesArray = allowedFileTypes.Value.toString().split(",");
    //check if file type is
    let ext = fileName.split(".")[1].toUpperCase();
    let count = fileTypesArray.length;
    for (let iter = 0; iter < count; iter++) {
      if (fileTypesArray[iter] == ext) return iter;
    }
    return -1;
  }

  checkFileSize(fileSize: number) {
    // get the maximum file size
    let allowedFileSize = environment.authWebApi.systemData.Configurations.find(
      (p) => p.Code == "MaxUploadMB1"
    );
    let maxAllowedSize = allowedFileSize.Value; //it is in MB
    let document_sizeMB = fileSize / 1000000;
    if (document_sizeMB <= maxAllowedSize) return 1;
    else return -1;
    //
  }
  validateData(documenttypeid: any) {
    if (this.carrier_id == null) {
      // this.dialogService.addDialog(AlertComponent, { title: 'Error', message: 'Unable to upload documents ' })
      this.toastService.error("Unable to upload documents ", "Error");
    } else {
      this.postFile(this.carrier_id, documenttypeid);
    }
  }

  postFile(CarrierID: any, documenttypeid: any) {
    //this.uploader.nativeElement.value = ''

    const formdata = new FormData();
    formdata.append("File", this.filebytes);
    formdata.append("FileName", this.filename);
    formdata.append("TypeOfFile", this.filetype);
    formdata.append("Notes", this.filedescription);
    formdata.append("FileSize", this.filesize);
    formdata.append("documenttypeid", documenttypeid);
    formdata.append("CarrierID", CarrierID);
    formdata.append("UserLastName", this.user.LastName);
    formdata.append("CarrierName", this.name);

    this.isLoading = true;

    this.message = "Uploading... please wait";

    this.documentService
      .postDocument(formdata, documenttypeid, CarrierID)
      .subscribe(
        (response) => {
          this.reload(); //,
          //this.dialogService.addDialog(AlertComponent, {
          //    title: 'File Uploaded',
          //    message: 'File: ' + this.filename + ' was successfully uploaded.',
          //    bold: this.filename
          //})
        },
        (error) => {
          this.isLoading = false;

          // this.dialogService.addDialog(ErrorComponent, {
          //     title: 'File Upload Failed, Please try again.',
          //     message: error._body , statuscode: error.Status, url: error.Uri, servermessage: error.Message
          // }),
          this.toastService.error(
            "File Upload Failed, Please try again.",
            " Error"
          );
          this.reload();
        }
      );
  }

  viewDoc(id, fileName) {
    //alert(id);
    //console.log(id)
    this.isViewMode = true;
    id = fileName.substring(fileName.indexOf("#") + 1);
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes(".pdf")) {
      this.documentService.downloadpdf(id).subscribe((x) => {
        console.log(x);

        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;

        //alert(this.pdfSrc.toString());
        //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.pdfSrc)
        this.isLoadingImg = false;
      });
      return;
    }

    this.documentService.download(id).subscribe((x) => {
      let objectURL = URL.createObjectURL(x);
      console.log(objectURL);
      this.pdfSrc = null;
      this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      console.log(this.img);
      this.isLoadingImg = false;
      // this.img = x;
    });
  }

  // viewDoc(fileName){
  //   //alert(fileName);
  //   this.isLoadingImg = true;
  //   this.doc = null;
  //   this.isPDF = 0;
  //  let id = fileName.substring(fileName.indexOf('#')+1);
  //  console.log(fileName)
  //   if(fileName.includes('.pdf')){
  //     this.documentService.downloadpdf(id).subscribe(x => {
  //       console.log(x);
  //       let objectURL = URL.createObjectURL(x);
  //       this.doc = objectURL;
  //       this.isPDF = 1;
  //       this.isLoadingImg = false;
  //     })
  //     return
  //   }
  //   this.documentService.download(id).subscribe(x => {
  //     let objectURL = URL.createObjectURL(x);
  //     this.isPDF = 2;
  //     this.doc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  //     this.isLoadingImg = false;
  //   })
  // }

  //Delete document changes
  onConfirm(doc: any) {
    // this.confirm.showYesNo('Delete Uploaded Document', `Are you sure you want to remove the file ${doc.file_name}  uploaded?`, null, 'Yes', 'No')
    //   .subscribe((isConfirmed) => {
    //     if (isConfirmed) {
    //       this.onDelete(doc)
    //     } else {
    //       return;
    //     }
    //   });
    this.confirmDialogService.confirmThis(
      `Are you sure you want to remove the file ${doc.file_name}  uploaded?`,
      () => {
        this.onDelete(doc);
      },
      () => {
        return;
      }
    );
  }
  extraDoc(doc) {
    this.DocTypesList.push(doc);
    this.toastService.error(
      "Please avoid using the same File Name on the document type!",
      ""
    );
  }

  checkIfKiosk() {
    this.documentService.checkIfKiosk().subscribe(
      (res: any) => {
        console.log(res);

        this.isKiosk = true;
      },
      (err) => {
        console.log(err.status);
      }
    );
  }

  scanDocument(id) {
    this.isLoadingImg = true;
    this.scanDocumentId = id;
    this.scanner.getKioskScanner().subscribe(
      (result: string) => {
        if (result) {
          this.scanner.getScannerByDeviceID(result.replace(" ", "")).subscribe(
            (response: any) => {
              if (response.status_id == 1014) {
                this.isPromptUserToScan = true;
                this.isViewMode = false;
                this.scannerMessage = `Please go and insert your paper to the scanner ${response.scanner_alias} and click the scan button `;
                response.status_id = 1015;
                response.pc_ip_address = result;
                response.status = null;
                this.selectedScanner = response;
                this.scanner.update(response).subscribe((res) => {});

                document.getElementById("btnView").click();
                this.isLoadingImg = false;
              } else {
                this.toastService.error(
                  `Scanner ${response.scanner_alias} is currently not available, please try again later`,
                  ""
                );
              }
            },
            (error) => {
              this.toastService.error(
                "An error occurred when getting the scanner details. Please try again later or contact the administrator",
                ""
              );
            }
          );
        }
      },
      (err) => {
        this.toastService.error(
          "An error occured getting the scanner details from the kiosk. Please try again later or contact the administrator",
          ""
        );
        this.isLoadingImg = false;
      }
    );
  }

  cancelScanner() {
    if (this.selectedScanner) {
      this.selectedScanner.status_id = 1014;
      this.scanner.update(this.selectedScanner).subscribe((res) => {});
    }
  }

  callTheScanner() {
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.scannedDocument = null;
    this.selectedScanner.status_id = 1015;
    this.scanner.update(this.selectedScanner).subscribe((res) => {});

    this.isPromptUserToScan = false;
    this.documentService.scanDocument().subscribe(
      (x) => {
        this.scannedDocument = x;
        let objectURL = URL.createObjectURL(x);

        this.pdfSrc = objectURL;
        this.isLoadingImg = false;
        this.selectedScanner.status_id = 1014;
        this.scanner.update(this.selectedScanner).subscribe((res) => {});
        //document.getElementById("btnView").click();

        //Post this document to sharepoint.
      },
      (error) => {
        this.toastService.error(
          "An error occured in scanner, please make sure the paper is properly placed in the scanner and retry to scan again.",
          ""
        );

        this.selectedScanner.status_id = 1014;
        this.scanner.update(this.selectedScanner).subscribe((res) => {
          this.isLoadingImg = false;
        });
      }
    );
  }

  postScannedDoc() {
    var reader = new FileReader();
    reader.removeEventListener;
    if (this.scannedDocument) {
      reader.readAsDataURL(this.scannedDocument);
      reader.onload = () => {
        this.filebytes = reader.result.toString().split(",")[1];
        this.filesize = this.scannedDocument.size.toString();
        this.filetype = this.scannedDocument.type;
        this.filename =
          "Scan" +
          this.datepipe.transform(new Date(), "ddMMyyyyHHmmss") +
          ".pdf";
        this.filedescription = "upload";
        document.getElementById("btnView").click();
        this.isLoadingImg = true;
        this.isLoading = true;
        this.validateData(this.scanDocumentId);
      };
    }
  }

  testscanDocument(id) {
    this.documentService.scanDocument().subscribe((x) => {
      let objectURL = URL.createObjectURL(x);

      var reader = new FileReader();
      reader.removeEventListener;
      reader.readAsDataURL(x);
      reader.onload = () => {
        this.filebytes = reader.result.toString().split(",")[1];
        this.filesize = x.size.toString();
        this.filetype = x.type;
        this.filename =
          "Scan" +
          this.datepipe.transform(new Date(), "ddMMyyyyHHmmss") +
          ".pdf";
        this.filedescription = "upload";

        console.log("Type", x.type);
        this.validateData(id);
      };
      //Post this document to sharepoint.
    });
  }
  onFileChange(event, documenttypeid) {
    let file: any = null;
    file = Object.keys(event).map((key) => event[key]);
    this.setDropFileData(file, "upload", documenttypeid);

    // this.toastr.info(`File uploaded successfully`, 'File Upload.');
  }
  setDropFileData(event: any, description: any, documenttypeid: any) {
    if (documenttypeid != null) {
      const reader = new FileReader();

      if (event && event.length > 0) {
        let file: any = null;
        const count = event.length;

        file = event[count - 1];
        let result = this.checkFileType(file.name);
        let fileFound = false;

        console.log("FileName", file.name);
        console.log("Docs", this.UserDocuments);

        this.UserDocuments.forEach(
          function (value) {
            if (file.name == value.file_name) {
              fileFound = true;
              this.toastService.error(
                `You already uploaded this file`,
                "File upload failed"
              );
              return false;
            }
          }.bind(this)
        );

        if (fileFound) {
          return;
        }

        //if File type is in not found
        if (result != -1) {
          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

            reader.removeEventListener;
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.filebytes = reader.result.toString().split(",")[1];
              (this.filename = file.name), (this.filetype = file.type);
              this.filedescription = description;
              this.filesize = file.size;
              this.validateData(documenttypeid);
            };
          } else {
            this.uploader.nativeElement.value = "";
            let allowedFileSize =
              environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == "MaxUploadMB1"
              );
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(
              `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
              "File Upload Failed, Please try again."
            );
          }
        } else {
          //send message allowed types
          this.uploader.nativeElement.value = "";
          let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
              (p) => p.Code == "UploadDocTypes1"
            );

          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed: PDF  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastService.error(
            `Only these file types are allowed: PDF`,
            "File Upload Failed, Please try again."
          );
        }
      }

      this.uploader.nativeElement.value = "";
      // this.showOtherUploadsOption = false;
    }
  }
}
